import type { ReactNode } from 'react';
import { Paper } from '@mui/material';

interface FormSectionProps {
  children: ReactNode;
}

export default function FormSection({ children }: FormSectionProps) {
  return (
    <Paper
      elevation={0}
      sx={{ p: 3, mb: 3, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}
    >
      {children}
    </Paper>
  );
}
